import { Box } from '@mui/material';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { CustomIcon } from 'modules/components/layer00';
import { SavePlanSetForm } from 'modules/components/layer12';
import React from 'react';
import { useParams } from 'react-router-dom';



export type SavePlanSetModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePlanSetModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      {...props}
      title='Save new plan set name'
      subTitle=''
      headerIcon={<CustomIcon.large.FC icon='CREATOR' />}
    >
      <Box
        height='inherit'
      >
        <SavePlanSetForm.FC
          id={props.id}
          projectId={params.projectId ?? ''}
          handleClose={props.handleClose}
        />
      </Box>
    </BasicFormModalLayout.FC>
  );
};
